<div class="db-booster-free-plan-intro__wrap">
  <h1>You have successfully<br> connected your website to 10Web</h1>
  <p class="mb20">
    Your current plan is <b>{{subscriptionTitle}}</b>
    <br> Image Optimizer is a part of 10Web Booster -<br>
    an all-in-one website optimization service for WordPress.
  </p>

  <div class="db-booster-free-plan-intro__features mb20">
    <i class="db-icon db-icon-ds-checkmark-bg"></i>
    <div>
      <p><b>Image Optimizer</b></p>
      <ul class="db-booster-free-plan-intro__features-list">
        <li *ngFor="let feature of imageOptimizer">
          <p><i class="db-icon db-icon-ds-dot"></i>{{feature}}</p>
        </li>
      </ul>
    </div>
  </div>

  <div class="db-booster-free-plan-intro__features">
    <i class="db-icon db-icon-ds-checkmark-bg"></i>
    <div>
      <div class="feature-title">
        <p><b>10Web Booster</b></p>
        <div *ngIf="!boosterIsActive" class="db-booster-free-plan-intro__label ml8">Not active</div>
      </div>
      <ul class="db-booster-free-plan-intro__features-list">
        <li *ngFor="let feature of booster">
          <p><i class="db-icon db-icon-ds-dot"></i>{{feature}}</p>
        </li>
      </ul>
    </div>
  </div>

  <div class="text-center mt30">
    <button class="ds-btn-green ds-btn-xl" (click)="redirectToWebsite()">
      <span>Explore</span>
    </button>
  </div>
</div>
<div class="db-booster-free-plan-intro__img-wrap"></div>
